import { useEffect, useRef, useState } from "react";
import cn from "classnames";
import s from "../sidebar.module.sass";

export function CollapsibleGroup({ label, icon, defaultOpen = true, children }: {
  label: string;
  icon?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(contentRef.current.scrollHeight);
    }
  }, [children]);

  return (
    <div>
      <div className={s.sectionHeader} onClick={() => setOpen((o) => !o)}>
        <span className={s.sectionLabel}>{icon}{label}</span>
        <svg
          className={cn(s.sectionChevron, { [s.open]: open })}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </div>
      <div
        ref={contentRef}
        className={cn(s.sectionItems, { [s.collapsed]: !open })}
        style={{ maxHeight: open ? height : 0 }}
      >
        {children}
      </div>
    </div>
  );
}
